
define('text!TescoMobile_Checkout/template/totals-item-payment-modal.html',[],function () { return '<%= data.content %>';});

